import { render, staticRenderFns } from "./Income.vue?vue&type=template&id=0c9bd706&scoped=true"
import script from "./Income.vue?vue&type=script&lang=js"
export * from "./Income.vue?vue&type=script&lang=js"
import style0 from "./Income.vue?vue&type=style&index=0&id=0c9bd706&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9bd706",
  null
  
)

export default component.exports